<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>요금사전결제</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">요금사전결제</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">요금 조회/결제</p>
          <ul class="depth">
            <li><router-link to="/prepaymentinfo" title="사전결제 안내">사전결제 안내</router-link></li>
            <li><router-link to="/lookup" title="요금 조회/결제">요금 조회/결제</router-link></li>
            <!-- <li><router-link to="/advancepayment" title="주차요금 간편조회">주차요금 간편조회</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사전 요금 결제</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                사전요금결제 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 120px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>
                    <strong class="colorType blue">{{ paymentInfo.carNo }}</strong>
                  </td>
                </tr>
                <tr>
                  <th scope="row">주차장</th>
                  <td>{{ paymentInfo.parkingName }}</td>
                </tr>
                <tr>
                  <th scope="row">이용시간</th>
                  <td>{{ paymentInfo.inDttm }} ~ {{ paymentInfo.outDttm }}</td>
                </tr>
                <tr>
                  <th scope="row">이용금액</th>
                  <td>{{ paymentInfo.useAmt | comma }}원</td>
                </tr>
                <tr>
                  <th scope="row">할인금액</th>
                  <td>{{ paymentInfo.discountAmt | comma }}원</td>
                </tr>
                <tr>
                  <th scope="row">차량번호할증금액</th>
                  <td>{{ paymentInfo.extraAmt | comma }}원</td>
                </tr>
<!--                <tr>-->
<!--                  <th scope="row">미납금액</th>-->
<!--                  <td>{{ totUnpaidAmt | comma }}원</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <th scope="row">미납가산금액</th>-->
<!--                  <td>{{ totAddAmt | comma }}원</td>-->
<!--                </tr>-->
                <tr>
                  <th scope="row">청구금액</th>
                  <td>
                    <strong class="colorType blue">{{ amount  | comma }}원</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
        </article>
        <article class="btnArea" v-if="prepayInfo.outDttm == null">
          <button class="btn gray" @click="cancelBtn">취소</button>
          <button class="btn blue" :disabled="amount <= 0" @click="paymentBtn">결제</button>
        </article>
        <article class="btnArea" v-else>
          <button class="btn gray" @click="cancelBtn">취소</button>
          <button class="btn blue" disabled>결제완료</button>
        </article>
      </div>
    </section>

    <!-- 스마트로 결제 폼 -->
    <form id="tranMgr" name="tranMgr" method="post">
      <input type="hidden" name="PayMethod" v-model="smartropayParms.PayMethod" />
      <input type="hidden" name="GoodsCnt" v-model="smartropayParms.GoodsCnt" />
      <input type="hidden" name="GoodsName" v-model="smartropayParms.goodsName" />
      <input type="hidden" name="Amt" v-model="smartropayParms.amount" />
      <input type="hidden" name="Moid" v-model="smartropayParms.moid" />
      <input type="hidden" name="Mid" v-model="smartropayParms.mid" />
      <input type="hidden" name="ReturnUrl" v-model="smartropayParms.returnUrl" />
      <input type="hidden" name="BuyerName" v-model="smartropayParms.buyerName" />
      <input type="hidden" name="BuyerTel" v-model="smartropayParms.buyerTel" />
      <input type="hidden" name="BuyerEmail" v-model="smartropayParms.BuyerEmail" />
      <input type="hidden" name="MallIp" v-model="smartropayParms.MallIp" />
      <input type="hidden" name="EncryptData" v-model="smartropayParms.encryptData" />
      <input type="hidden" name="EdiDate" v-model="smartropayParms.ediDate" />
      <input type="hidden" name="TaxAmt" v-model="smartropayParms.TaxAmt" />
      <input type="hidden" name="TaxFreeAmt" v-model="smartropayParms.TaxFreeAmt" />
      <input type="hidden" name="VatAmt" v-model="smartropayParms.VatAmt" />
    </form>

    <form id="approvalForm" name="approvalForm" method="post">
      <input type="hidden" id="Tid" name="Tid" />
      <input type="hidden" id="TrAuthKey" name="TrAuthKey" />
    </form>
    <!-- 스마트로 결제 폼 -->
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      prepayInfo: {
        inOutId: '',
        sectnId: '',
        carNo: '',
        inDttm: '',
        discountCd: '',
        extraCd: '',
        outDttm: '',
      },

      paymentInfo: '',
      totUnpaidAmt: '',
      totAddAmt: '',
      totSumAmt: '',
      amount: '',

      smartropayParms: {},
    };
  },

  mounted() {
    const data = this.$route.params.data;
    const sttus = this.$route.query.r;
    if (sttus == 'true') {
      alert('결제가 정상적으로 처리되었습니다.');
      this.$router.push('/lookup');
      return;
    } else if (sttus == 'false') {
      alert('결제에 실패하였습니다. 다시 시도해주세요.');
      this.$router.push('/lookup');
      return;
    }
    if (data) {
      this.prepayInfo.inOutId = data.inOutId;
      this.prepayInfo.sectnId = data.sectnId;
      this.prepayInfo.carNo = data.carNo;
      this.prepayInfo.inDttm = data.inDttm;
      this.prepayInfo.discountCd = data.discountCd;
      this.prepayInfo.extraCd = data.extraCd;
      this.prepayInfo.outDttm = data.outDttm;
      this.getPaymentInfo();
    }
  },

  methods: {
    cancelBtn() {
      this.$router.push({
        name: 'lookup',
      });
    },

    async getPaymentInfo() {
      let apiParams = new Map();
      apiParams.set('inOutId', this.prepayInfo.inOutId);
      apiParams.set('sectnId', this.prepayInfo.sectnId);
      apiParams.set('carNo', this.prepayInfo.carNo);
      apiParams.set('inDttm', this.prepayInfo.inDttm);
      apiParams.set('discountCd', this.prepayInfo.discountCd);
      apiParams.set('extraCd', this.prepayInfo.extraCd);
      apiParams.set('myPage', 'N');

      const res = await axios('get', '/api/prepay/view.json', Object.fromEntries(apiParams));
      const resData = res.data;

      this.paymentInfo = resData.resultMap.result;
      this.totUnpaidAmt = resData.totUnpaidAmt;
      this.totAddAmt = resData.totAddAmt;
      this.totSumAmt = resData.totSumAmt;

      this.amount = resData.resultMap.easypayParams.amount;
    },

    async paidValid() {
      const res = await axios('get', '/api/prepay/view.json', {
        inOutId: this.prepayInfo.inOutId,
        sectnId: this.prepayInfo.sectnId,
        carNo: this.prepayInfo.carNo,
        inDttm: this.prepayInfo.inDttm,
        discountCd: this.prepayInfo.discountCd,
        extraCd: this.prepayInfo.extraCd,
        myPage: 'N',
      });
      const resData = res.data;
      const freshAmount = resData.resultMap.easypayParams.amount;

      if (freshAmount !== this.amount) {
        alert('금액이 변경되었습니다. 다시 확인해주세요.');
        this.paymentInfo = resData.resultMap.result;
        this.totUnpaidAmt = resData.totUnpaidAmt;
        this.totAddAmt = resData.totAddAmt;
        this.totSumAmt = resData.totSumAmt;
        this.amount = freshAmount;
        return false;
      }

      return true;
    },

    async paymentBtn() {
      if (this.prepayInfo.inOutIds == '') {
        alert('결제 정보가 없습니다.');
        this.$router.push('/lookup');
        return;
      }

      const isValid = await this.paidValid();
      if (!isValid) {
        return;
      }

      let apiParams = new FormData();
      const memberInfoId = this.$store.state.empNo ? this.$store.state.empNo : this.carNo;
      apiParams.append('amount', this.amount);
      apiParams.append('inOutId', this.prepayInfo.inOutId);
      apiParams.append('payCategory', 'PRESETTLEMENT');
      apiParams.append('isStatus', false);
      apiParams.append('memberInfoId', memberInfoId);
      apiParams.append('carNumber', this.prepayInfo.carNo);
      apiParams.append('period', '');
      const res = await axios('post', '/api/smartropay/payment', apiParams);
      const { ediDate = '', encryptData = '', mid = '', amount = '', paymentId = '' } = res.data.result;
      const RETURN_URL = `${process.env.VUE_APP_DOMAIN}/api/smartropay/callApproval/paymentview/${paymentId}`;

      const TaxFreeAmt = 0;
      const tmp = amount / 1.1;
      const VatAmt = Math.floor(amount - tmp);
      const TaxAmt = amount - VatAmt;

      const buyerName = this.$store.state.empNm ? this.$store.state.empNm : this.prepayInfo.carNo;
      const buyerTel = this.$store.state.empMobile ? this.$store.state.empMobile : '01000000000';

      this.smartropayParms = {
        goodsName: `사전결제_${buyerName}_${amount}원`,
        amount: amount,
        moid: paymentId,
        mid: mid,
        returnUrl: RETURN_URL,
        StopUrl: RETURN_URL,
        buyerName: buyerName,
        buyerTel: buyerTel,
        encryptData: encryptData,
        ediDate: ediDate,
        TaxAmt: TaxAmt,
        VatAmt: VatAmt,
        TaxFreeAmt: TaxFreeAmt,
        PayMethod: 'CARD',
        GoodsCnt: 1,
        BuyerEmail: 'noname@smartro.co.kr',
        MallIp: '211.57.44.13',
      };

      await smartropay.init({
        mode: process.env.VUE_APP_SMARTRO_INIT,
      });

      await smartropay.payment({
        FormId: 'tranMgr',
        Callback: function (res) {
          var approvalForm = document.approvalForm;
          approvalForm.Tid.value = res.Tid;
          approvalForm.TrAuthKey.value = res.TrAuthKey;
          approvalForm.action = RETURN_URL;
          approvalForm.submit();
        },
      });
    },
  },
};
</script>
